import { GeoLocationStatus } from '@endeavour/enhanced-geo-integration';
import { GeoLocationError } from '@endeavour/enhanced-geo-integration/src/interface/errors.interface';
import { XPointErrorCode } from './error.interface.js';

function isCustomEvent(event) {
    return event && event.detail;
}
function convertStatus(status) {
    switch (status) {
        case 'WAITING':
            return GeoLocationStatus.PENDING;
        case 'DENIED':
            return GeoLocationStatus.DENIED;
        case 'ALLOWED':
            return GeoLocationStatus.ALLOWED;
    }
    return GeoLocationStatus.PENDING;
}
function convertError(error) {
    switch (error.code) {
        case XPointErrorCode.DEVICE_TAMPERING_DETECTED:
            return GeoLocationError.DEVICE_TAMPERING_DETECTED;
        case XPointErrorCode.NOT_ENOUGH_ACCURACY:
            return GeoLocationError.NOT_ENOUGH_ACCURACY;
        case XPointErrorCode.OUT_OF_BOUNDS:
            return GeoLocationError.OUT_OF_BOUNDS;
        case XPointErrorCode.POTENTIAL_SPOOFING:
            return GeoLocationError.POTENTIAL_SPOOFING;
        case XPointErrorCode.PROXY_DETECTED:
            return GeoLocationError.PROXY_DETECTED;
        case XPointErrorCode.REMOTE_DESKTOP_DETECTED:
            return GeoLocationError.REMOTE_DESKTOP_DETECTED;
        case XPointErrorCode.RUNNING_ANONYMIZER:
            return GeoLocationError.VPN_DETECTED;
        case XPointErrorCode.SOFTWARE_OUT_OF_DATE:
            return GeoLocationError.SOFTWARE_OUT_OF_DATE;
        case XPointErrorCode.TIME_SHIFT_DETECTED:
            return GeoLocationError.MODIFIED_TIME_DETECTED;
        case XPointErrorCode.TOO_CLOSE_TO_BOUNDS:
            return GeoLocationError.TOO_CLOSE_TO_BOUNDS;
    }
    return GeoLocationError.UNKNOWN_ERROR;
}

export { convertError, convertStatus, isCustomEvent };
